module.exports = __webpack_public_path__ + "img/item-info-icon3.39a237b2.svg";